// The existing typing component, preserved from assets/search.js.
// Load only this guarded component; other pages load their own predictive-search controller.
if (!customElements.get('smx-search-messages')) {
  customElements.define('smx-search-messages', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.input = this.parentElement.querySelector('input[type="search"]');
      this.output = this.querySelector('[data-smx-search-text]');
      this.messages = Array.from(this.querySelectorAll('[data-smx-search-message]'), node => Array.from(node.textContent.trim())).filter(message => message.length);
      if (!this.input || !this.output || !this.messages.length) return;
      this.text = document.createTextNode('');
      this.output.replaceChildren(this.text);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.speed = Math.max(25, Number(this.dataset.speed) || 65);
      this.hold = Math.max(1000, Number(this.dataset.pause) || 2500);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.refresh = this.sync.bind(this);
      ['focus', 'blur', 'input', 'change'].forEach(event => this.input.addEventListener(event, this.refresh, options));
      document.addEventListener('visibilitychange', this.refresh, options);
      this.motion.addEventListener('change', this.refresh, options);
      this.observer = new ResizeObserver(() => {
        this.align();
        this.sync();
      });
      this.observer.observe(this.input);
      this.align();
      this.sync();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.input?.classList.remove('smx-search-messages-active');
    }

    available() {
      return !document.hidden && this.input.value.length === 0 && document.activeElement !== this.input && this.visible;
    }

    align() {
      const input = this.input.getBoundingClientRect();
      const field = this.parentElement.getBoundingClientRect();
      const style = getComputedStyle(this.input);
      const left = Math.max(0, input.left - field.left + parseFloat(style.paddingLeft)) + 'px';
      const right = Math.max(0, field.right - input.right + parseFloat(style.paddingRight)) + 'px';
      const font = style.font;
      const letterSpacing = style.letterSpacing;
      const direction = style.direction;
      this.visible = input.width > 0 && input.height > 0;
      this.style.left = left;
      this.style.right = right;
      this.style.font = font;
      this.style.letterSpacing = letterSpacing;
      this.style.direction = direction;
    }

    sync() {
      clearTimeout(this.timer);
      const active = this.available();
      this.hidden = !active;
      this.input.classList.toggle('smx-search-messages-active', active);
      if (!active) return;
      this.messageIndex = 0;
      this.position = 0;
      this.deleting = false;
      if (this.motion.matches) {
        this.text.data = this.messages[0].join('');
        return;
      }
      this.text.data = '';
      this.timer = setTimeout(() => this.tick(), 350);
    }

    tick() {
      if (!this.available()) {
        this.sync();
        return;
      }
      const message = this.messages[this.messageIndex];
      this.position += this.deleting ? -1 : 1;
      this.text.data = message.slice(0, this.position).join('');
      let delay = this.deleting ? Math.max(20, this.speed * 0.55) : this.speed;
      if (!this.deleting && this.position >= message.length) {
        this.deleting = true;
        delay = this.hold;
      } else if (this.deleting && this.position <= 0) {
        this.deleting = false;
        this.messageIndex = (this.messageIndex + 1) % this.messages.length;
        delay = 350;
      }
      this.timer = setTimeout(() => this.tick(), delay);
    }
  });
}

